import script from "./WhatsAppConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsAppConfig.vue?vue&type=script&setup=true&lang=js"

import "./WhatsAppConfig.vue?vue&type=style&index=0&id=1c724ef6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c724ef6"]])

export default __exports__